import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { GlassIcon } from '../../components/common/GlassIcon';

export const SuspendedAccount = () => {
  const { signOut } = useAuth();

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 py-8 relative overflow-hidden"
      style={{
        backgroundImage: "url('/images/desert-dark.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/70 pointer-events-none"></div>

      <div
        className="p-8 w-full max-w-lg text-center relative z-10 animate-slide-up rounded-2xl"
        style={{
          background: 'rgba(0,0,0,0.7)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.15)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        }}
      >
        <div className="w-24 h-24 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white/20">
          <GlassIcon name="alert-triangle" size={48} className="text-white" />
        </div>
        
        <h2 className="text-3xl font-black mb-4 text-white">حسابك موقوف ⚠️</h2>
        
        <p className="mb-8 text-gray-400 leading-relaxed">
          عذراً، تم إيقاف حسابك من قبل الإدارة. لا يمكنك الوصول إلى محتوى المنصة في الوقت الحالي.
          يرجى التواصل مع الدعم الفني أو السنتر لمزيد من التفاصيل أو لحل المشكلة.
        </p>

        <button
          onClick={signOut}
          className="w-full bg-white hover:bg-gray-200 text-black py-4 rounded-xl font-bold flex items-center justify-center gap-3 transition shadow-lg"
        >
          <GlassIcon name="log-out" size={20} />
          تسجيل الخروج والعودة للرئيسية
        </button>
      </div>
    </div>
  );
};
